import { Link } from "react-router-dom";
import { BUDGET_ALERT_CENTS, formatCents } from "../lib/ai-costs/format";
import type { AiBudgetState } from "../lib/app-config/ai-budget";

interface BudgetAlertBannerProps {
  state: AiBudgetState | null;
  isAdmin: boolean;
}

// Bannière ADMIN-ONLY (Phase C tracking dépenses IA, mini-spec §4) : visible
// dès que le budget IA du mois dépasse le seuil d'alerte (50 $), tant que la
// suspension (150 $) n'est PAS encore atteinte — au-delà, `BudgetSuspendedBanner`
// (plus sévère, tous usagers) prend le relais seule. Patron de bannière :
// `AbandonedNotice` (filet ambre, `role="status"`). Seuil importé de
// `ai-costs/format.ts` (source unique côté client, pas de duplication littérale).
export function BudgetAlertBanner({ state, isAdmin }: BudgetAlertBannerProps) {
  if (!isAdmin || !state?.alert || state.suspended) return null;

  return (
    <div
      role="status"
      className="flex flex-col gap-2 rounded-r-md border-l-2 border-amber-400 bg-amber-50 px-3 py-3 text-small text-ink"
    >
      <p className="m-0">
        Le budget IA du mois a dépassé le seuil d'alerte ({formatCents(BUDGET_ALERT_CENTS)}).
      </p>
      <Link
        to="/depenses-ia"
        className="self-end text-label font-medium text-flambeau-700 underline decoration-dotted hover:text-flambeau-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange"
      >
        Voir Dépenses IA →
      </Link>
    </div>
  );
}
